import { Theme } from '@mui/material/styles';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded';

export default function Checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckBoxOutlineBlankRoundedIcon />,
        checkedIcon: <CheckBoxRoundedIcon />,
        indeterminateIcon: <IndeterminateCheckBoxRoundedIcon />,
      },
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
          '&.Mui-checked': {
            color: theme.palette.accent.main,
          },
          '&.MuiCheckbox-indeterminate': {
            color: theme.palette.accent.main,
          },
        },
      },
    },
  };
}
